import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from "antd";
const { useToken } = theme;
/**
 * Icon for the success severity.
 */
export default function SuccessIcon() {
    const { token } = useToken();
    return (_jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M12 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5Zm0 2a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Z", fill: token.colorSuccess }), _jsx("path", { fill: token.colorSuccessText, d: "M16.382 8.273h-1.1a.746.746 0 0 0-.606.312l-3.685 5.11-1.668-2.316a.75.75 0 0 0-.608-.312H7.616c-.152 0-.241.174-.152.298l2.92 4.05a.746.746 0 0 0 1.212 0l4.936-6.844a.187.187 0 0 0-.15-.298Z" })] }));
}
